/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2021
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/
import { defineMessages } from 'react-intl';

export const AdvancedOptions = defineMessages({
  title: {
    id: 'whatsapp.AdvancedOptions.title',
    defaultMessage: 'Preset messages'
  },
  subtitle: {
    id: 'whatsapp.AdvancedOptions.subtitle',
    defaultMessage:
      'These messages are used specifically with the WhatsApp integration under scenarios that WhatsApp cannot respond as expected.'
  },
  configuredMessageLabel: {
    id: 'whatsapp.AdvancedOptions.configuredMessageLabel',
    defaultMessage: 'When returning buttons or options to the user'
  },
  runtimeErrorLabel: {
    id: 'whatsapp.AdvancedOptions.runtimeErrorLabel',
    defaultMessage: 'When there is an error'
  },
  transferErrorLabel: {
    id: 'whatsapp.AdvancedOptions.transferErrorLabel',
    defaultMessage: 'Response to Connect to Agent response type'
  },
  configuredMessageDefault: {
    id: 'whatsapp.AdvancedOptions.configuredMessageDefault',
    defaultMessage: 'Reply with the option number.'
  },
  configuredMessageRequired: {
    id: 'whatsapp.AdvancedOptions.configuredMessageRequired',
    defaultMessage: 'Options configured message is required.'
  },
  runtimeErrorMessageRequired: {
    id: 'whatsapp.AdvancedOptions.runtimeErrorMessageRequired',
    defaultMessage: 'Runtime error message is required.'
  },
  runtimeErrorMessageDefault: {
    id: 'whatsapp.AdvancedOptions.runtimeErrorMessageDefault',
    defaultMessage:
      "Hmmm... I'm experiencing some difficulties. I need a human agent to manually continue the conversation."
  },
  transferErrorMessageDefault: {
    id: 'whatsapp.AdvancedOptions.transferErrorMessageDefault',
    defaultMessage:
      "Hmmm... I'm experiencing some difficulties, and can't seem to transfer you to a human agent at the moment. Please try again in a bit."
  },
  transferErrorMessageRequired: {
    id: 'whatsapp.AdvancedOptions.transferErrorMessageRequired',
    defaultMessage: 'Transfer error message is required.'
  },
  transferErrorDescription: {
    id: 'whatsapp.AdvancedOptions.transferErrorDescription',
    defaultMessage:
      '<link>Learn more</link> about transferring channels instead.'
  }
});
